import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import Foooter from "../Foooter";
import { useParams, Link } from "react-router-dom";
import "../../style/InfoCar.css";
import api from "../../utils/apiClient";
import FooterMovil from "../FooterMovil";
import PopupLogged from "../PopupLogged";
import { useAuth } from "../../context/AuthContext.js";
import Popup360 from '../Popup360'; // Asegúrate de que la ruta sea correcta

function InfoCar() {
  const [showComponentA, setShowComponentA] = useState(true);
  const [link360, setLink360] = useState("");
  const { authToken } = useAuth();

  const toggleComponent = () => {
    setShowComponentA(!showComponentA);
  };

  const [car, setCar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [, setError] = useState(null);

  const { id } = useParams();

  const [images, setimages] = useState([]);

  const [mainImage, setMainImage] = useState(images[0]);

  const handleImageClick = (imageUrl) => {
    setMainImage(imageUrl);
  };

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${day}/${month}/${year}`;
  }

  function formatPhoneNumber(phone) {
    return phone.replace(/\D/g, ''); // remove everything except digits
  }

  const solicitarCompra = async () => {
    if(authToken){
      const data = {
        data: "data",
      };
      if(authToken){
        await api.post("ventas/solicitudcompra/" + id, data);
      }
    }
    if(car.thirdPartySeller){
      const phoneNumber = formatPhoneNumber(car.contacto)
      const message = `quiero comprar el vehiculo ` + car.marca + " " + car.modelo + " " + car.anio + " numero de lote " + car.lote;
      const url = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message)
      await window.open(url, '_blank')
    } else {
      const phoneNumber = "50499700699";
      const message = `quiero comprar el vehiculo ` + car.marca + " " + car.modelo + " " + car.anio + " numero de lote " + car.lote;
      const url = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message)
      await window.open(url, '_blank')
    }
    
  };

  useEffect(() => {
    const fetchAllCarros = async () => {
      setLoading(true);
      try {
        const response = await api.get("carro/" + id);
        setCar(response.data);
        let imageUrls = response.data.imagenes
        imageUrls = imageUrls.map(url => url.replace("http://", "https://"));
        setMainImage(imageUrls[0]);
        setimages(imageUrls);
        setLink360(response.data.link360);
        setError(null);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to fetch data");
        setCar([]);
        setLoading(false);
      }
    };
    fetchAllCarros();
  }, [id]);

  const [otherloading, othersetloading] = useState(false)

  const viewRecent =  async () => {
    if(otherloading){
      return 
    }

    othersetloading(true);

    const data = {}
    try {
      await api.post("carro/viewRecent/" + id, data);
    } catch (error) {
      setError("Failed to fetch data");
      console.error('Failed to fetch items', error);
    } finally {
      othersetloading(false);
    }
      
    
  }

  useEffect(() => {
    if(authToken){
      viewRecent()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  if (loading) {
    return <div>Cargando...</div>;
  }

  const isOnSale = Boolean(car.offerta) && Number(car.precioOferta) > 0;
  const displayPrice = isOnSale ? car.precioOferta : car.precio;

  return (
    <>
      <Navbar />
      <div className="infoCar-container">
        <div className="columns-info">
          <h1 className="car-title">
            {car.marca} {car.modelo} {car.anio}
            {car.thirdPartySeller && (
              <span className="third-party-badge">Vendedor Externo</span>
            )}
          </h1>
          <div
            className="normal-set"
            style={{ display: showComponentA ? "block" : "none" }}
          >
            <div className="hero-image-wrap">
              {isOnSale && <span className="hero-sale-badge">Oferta</span>}
              <button className="change-set" onClick={toggleComponent}>
                Vista Completa
              </button>
              <Popup360 link360={link360} />
              {mainImage ? (
                <img src={mainImage} alt="" className="main-image" />
              ) : null}
            </div>
            <div className="thumbnails-row">
              {images.map((image, index) => (
                <button
                  key={index}
                  type="button"
                  className={`thumbnail${image === mainImage ? " thumbnail--active" : ""}`}
                  onClick={() => handleImageClick(image)}
                  aria-label={`Mostrar imagen ${index + 1}`}
                >
                  <img src={image} alt={`Miniatura ${index + 1}`} />
                </button>
              ))}
            </div>
          </div>
          <div
            className="column-set"
            style={{
              display: showComponentA ? "none" : "flex",
            }}
          >
            <button className="change-set change-set--inline" onClick={toggleComponent}>
              Vista Normal
            </button>
            <div className="images-info-2">
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Thumbnail ${index}`}
                  className="columset-img"
                />
              ))}
            </div>
          </div>
        </div>
        <div className="columns-car-info-not-subasta">
          <div className="info-card-header">
            <div className="price-block">
              {isOnSale && <span className="price-badge">Oferta</span>}
              <p className="price-label">Precio</p>
              <p className="price-value" spellCheck="false" translate="no">
                Lps. {formatNumberWithCommas(displayPrice)}
              </p>
              {isOnSale && (
                <p className="price-original">
                  Lps. {formatNumberWithCommas(car.precio)}
                </p>
              )}
            </div>
          </div>

          <div className="info-section">
            <h3 className="info-section-title">Especificaciones</h3>
            <div className="info-grid">
              {car.tipo !== 'Varios' && (
                <div className="info-row">
                  <span className="info-label">Lote</span>
                  <span className="info-value">{car.lote}</span>
                </div>
              )}
              <div className="info-row">
                <span className="info-label">Fecha de publicación</span>
                <span className="info-value">{formatDate(car.createdAt)}</span>
              </div>
              <div className="info-row">
                <span className="info-label">{car.tipo !== 'Varios' ? 'Marca' : 'Producto'}</span>
                <span className="info-value">{car.marca}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Modelo</span>
                <span className="info-value">{car.modelo}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Año</span>
                <span className="info-value">{car.anio}</span>
              </div>
              {car.millaje !== 0 && (
                <div className="info-row">
                  <span className="info-label">Millaje</span>
                  <span className="info-value">{formatNumberWithCommas(car.millaje)}</span>
                </div>
              )}
              <div className="info-row">
                <span className="info-label">Condición</span>
                <span className="info-value">{car.condicion}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Tipo</span>
                <span className="info-value">{car.tipo}</span>
              </div>
              <div className="info-row">
                <span className="info-label">Ubicación</span>
                <span className="info-value">{car.ubicacion}</span>
              </div>
              {car.motor !== '0' && (
                <div className="info-row">
                  <span className="info-label">Motor</span>
                  <span className="info-value">{car.motor}</span>
                </div>
              )}
              {car.combustible !== 'N/A' && (
                <div className="info-row">
                  <span className="info-label">Combustible</span>
                  <span className="info-value">{car.combustible}</span>
                </div>
              )}
              {car.transmission !== 'N/A' && (
                <div className="info-row">
                  <span className="info-label">Transmisión</span>
                  <span className="info-value">{car.transmission}</span>
                </div>
              )}
              {car.traccion !== 'N/A' && (
                <div className="info-row">
                  <span className="info-label">Tracción</span>
                  <span className="info-value">{car.traccion}</span>
                </div>
              )}
              {car.listado && (
                <div className="info-row">
                  <span className="info-label">Listado</span>
                  <span className="info-value">{car.listado}</span>
                </div>
              )}
            </div>
          </div>

          <div className="info-section">
            <h3 className="info-section-title">Estado del vehículo</h3>
            <div className="info-chips">
              <span className={`info-chip${car.camina ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.camina ? '✓' : '✕'} Camina
              </span>
              <span className={`info-chip${car.enciende ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.enciende ? '✓' : '✕'} Enciende
              </span>
            </div>
          </div>

          <div className="info-section">
            <h3 className="info-section-title">Costos incluidos</h3>
            <div className="info-chips">
              <span className={`info-chip${car.gruaIncluida ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.gruaIncluida ? '✓' : '✕'} Grúa
              </span>
              <span className={`info-chip${car.Introduccion ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.Introduccion ? '✓' : '✕'} Introducción
              </span>
              <span className={`info-chip${car.gastosDeInscripcion ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.gastosDeInscripcion ? '✓' : '✕'} Inscripción
              </span>
              <span className={`info-chip${car.costosPlacas ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.costosPlacas ? '✓' : '✕'} Placas
              </span>
              <span className={`info-chip${car.viasPublicas ? ' info-chip--yes' : ' info-chip--no'}`}>
                {car.viasPublicas ? '✓' : '✕'} Vías Públicas
              </span>
            </div>
          </div>

          {car.comentario && car.comentario !== "" && (
            <div className="info-section">
              <h3 className="info-section-title">Comentario</h3>
              <p className="info-comment">{car.comentario}</p>
            </div>
          )}

          <div className="info-cta">
            {car.enSubasta ? (
              // The car's sale runs through its auction — the regular purchase
              // request is blocked server-side too (carro en subasta activa).
              <Link to={"/subasta/" + car._id} className="info-auction-cta">
                Este carro está en subasta — Ver subasta →
              </Link>
            ) : (
              <PopupLogged solicitarCompra={solicitarCompra}/>
            )}
          </div>
        </div>
      </div>
      <div className="footer">
        <Foooter />
      </div>
      <div className="footer-movil">
        <FooterMovil />
      </div>
    </>
  );
}

export default InfoCar;
